module.exports = __webpack_public_path__ + "img/vote-logo.3b092f90.png";